angular.module('property-deal')
    .factory('PropertyDealPaymentRegistry', function ($resource) {
        return $resource('/crm/api/property-deal/:id/payment-registry', {id: "@id"}, {})
    })
    .component('propertyDealPaymentRegistry', {
        bindings: {
            propertyDealId: '<',
            totalPricing: '<',
            disabled: '<'
        },
        templateUrl: 'app/property-deal/payment-registry-show.html',
        controller: function ($scope, modals, PropertyDealPaymentRegistry, InvoiceService) {
            this.$onChanges = () => {
                this.propertyDealTotal = this.totalPricing.totalGross
                PropertyDealPaymentRegistry.get({id: this.propertyDealId}).$promise.then(result => {
                    this.item = result
                    this.calculateTotal()
                }).catch(() => {
                    this.item = {
                        items: []
                    }
                    this.calculateTotal()
                })
            }

            this.edit = () => {
                modals.open('app/property-deal/payment-registry-edit.html', 'PropertyDealPaymentRegistryEditController', {id: this.propertyDealId, total: this.propertyDealTotal}, {size: "lg"}, "$ctrl").then(() => this.$onChanges())
            }

            this.calculateTotal = () => {
                let totalAmount = InvoiceService.sumDecimal(this.item.items.map(item => item.amount));
                let totalAmountIN = InvoiceService.sumDecimal(this.item.items.map(item => item.amount).filter(item => item > 0));
                let totalAmountOUT = InvoiceService.sumDecimal(this.item.items.map(item => item.amount).filter(item => item < 0));
                this.total = {
                    amount: totalAmount,
                    amountIN: totalAmountIN,
                    amountOUT: totalAmountOUT
                }
                let totalLeftAmount = InvoiceService.sub(this.propertyDealTotal, totalAmount);
                this.totalLeft = {
                    amount: totalLeftAmount
                }
            }
        }
    })
    .controller('PropertyDealPaymentRegistryEditController', function ($http, toastr, modals, $scope, $rootScope, $uibModalInstance, data, PropertyDealPaymentRegistry, InvoiceService) {
        this.$onInit = () => {
            this.propertyDealTotal = data.total
            PropertyDealPaymentRegistry.get({id: data.id}).$promise.then(result => {
                this.item = result
                this.calculateTotal()
            })
        }
        this.add = () => {
            this.item.items.push({})
        }
        this.addAmount = (amount) => {
            let item = this.item.items.find(item => item.amount == null);
            if(item == null) {
                item = {
                    amount: amount,
                }
                this.item.items.push(item)
            }
            else {
                item.amount = amount
            }
            this.onAmountChanged(item)
        }
        this.remove = ($index) => {
            this.item.items.splice($index, 1)
            this.calculateTotal()
        }
        this.onAmountChanged = (item) => {
            this.calculateTotal()
        }
        this.calculateTotal = () => {
            let totalAmount = InvoiceService.sumDecimal(this.item.items.map(item => item.amount));
            this.total = {
                amount: totalAmount
            }
            let totalLeftAmount = InvoiceService.sub(this.propertyDealTotal, totalAmount);
            this.totalLeft = {
                amount: totalLeftAmount
            }
        }
        this.cancel = () => $uibModalInstance.dismiss('Canceled');
        this.delete = () => {
            return modals.confirmDelete("rejestr", () => PropertyDealPaymentRegistry.delete({id: data.id}).$promise.then(() => {
                $rootScope.$broadcast('property-deal.updated')
                $uibModalInstance.close()
            }))
        }
        this.save = () => {
            let form = {
                id: data.id,
                ...this.item
            }
            return PropertyDealPaymentRegistry.save(form).$promise.then(result => {
                $rootScope.$broadcast('property-deal.updated', result);
                $uibModalInstance.close(result);
            })
        }
    })
